import { render, staticRenderFns } from "./deleteContractType.vue?vue&type=template&id=106c4006&scoped=true"
import script from "./deleteContractType.vue?vue&type=script&lang=js"
export * from "./deleteContractType.vue?vue&type=script&lang=js"
import style0 from "./deleteContractType.vue?vue&type=style&index=0&id=106c4006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c4006",
  null
  
)

export default component.exports